module.exports = __webpack_public_path__ + "static/img/1.728214e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/1.jpg
// module id = ol+I
// module chunks = 1